import { render, staticRenderFns } from "./AdsViewer.vue?vue&type=template&id=7471dc27&scoped=true"
import script from "./AdsViewer.vue?vue&type=script&lang=js"
export * from "./AdsViewer.vue?vue&type=script&lang=js"
import style0 from "./AdsViewer.vue?vue&type=style&index=0&id=7471dc27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471dc27",
  null
  
)

export default component.exports